import React, {Component} from "react";
import MenuGroup from "./MenuGroup";

class ProfileMenu extends Component {

  render() {

    return (
      <MenuGroup label="My Account" profile={true}>
        <span className="item" onClick={this.props.onLogout}>Logout</span>
      </MenuGroup>
    )

    // return (
    //   <Query query={GET_PROFILE} fetchPolicy="network-only">
    //     {({ client, loading, error, data }) => {
    //       if (!loading && data && data.profile) {
    //         return (
    //           <MenuGroup label={data.profile.name} profile={true}>
    //             <span className="item" onClick={this.props.onLogout}>Logout</span>
    //           </MenuGroup>
    //         )
    //       }
    //       return <MenuGroup label="..." profile={true} />
    //     }}
    //   </Query>      
    // )
  }

}

ProfileMenu.defaultProps = {
  label: "..."
}

export default ProfileMenu;